module.exports = __webpack_public_path__ + "static/media/PATS_1-277w.8a2e7ca8.webp";